import { lazy, Suspense } from "react"

const ExcelGenerator = lazy(() => import("components/common/ExcelGenerator"))
const ImageLightbox = lazy(() => import("components/common/ImageLightbox"))

/**
 * Kendo Excel + lightbox are not needed for first route paint; load on demand.
 */
export function LazyGlobalOverlays() {
  return (
    <Suspense fallback={null}>
      <ExcelGenerator storeName="appStore.excelGenerator" />
      <ImageLightbox storeName="appStore.imageLightbox" />
    </Suspense>
  )
}
